import React, { Component } from 'react';
import axios from 'axios';
import Chatkit from '@pusher/chatkit-client';
import { sendMessage, handleInput, connectToRoom } from './screens/sharedMethods.js';

import './Support.css';

class Support extends Component {
  constructor() {
    super();

    this.state = {
      currentUser: null,
      currentRoom: null,
      newMessage: "",
      messages: [],
      rooms: []
    };

    this.sendMessage = sendMessage.bind(this);
    this.handleInput = handleInput.bind(this);
    this.connectToRoom = connectToRoom.bind(this);
  }

  componentDidMount() {
    const userId = "support";

    axios.post('https://us1.pusherplatform.io/services/chatkit_token_provider/v1/ad7d7c1e-cb76-4410-96a2-c41640d70d80/token', { userId }).then(() => {
      const tokenProvider = new Chatkit.TokenProvider({
        url: 'https://us1.pusherplatform.io/services/chatkit_token_provider/v1/ad7d7c1e-cb76-4410-96a2-c41640d70d80/token'
      });

      const chatManager = new Chatkit.ChatManager({
        instanceLocator: "v1:us1:ad7d7c1e-cb76-4410-96a2-c41640d70d80",
        userId,
        tokenProvider
      });

      return chatManager.connect({ onAddedToRoom: room => {
        this.setState({
          rooms: [...this.state.rooms, room]
        });
      }}).then(currentUser => {
        this.setState({
          currentUser,
          rooms: currentUser.rooms
        },
        () => {
          if (this.state.rooms.lenght >= 1) {
            this.connectToRoom(this.state.rooms[0].id);
          }
        }
      );
    });
  }).catch(console.error);
  }

  joinRoom = id => {
    this.setState({
      messages: []
    },
      () => this.connectToRoom(id)
    );
  };


  render() {
    const { newMessage, rooms, currentRoom, messages, currentUser } = this.state;

    const RoomList = rooms.map(room => {
      const isActive = currentRoom && currentRoom.id === room.id ? "active" : "";
      return(
        <li
          key={room.id}
          onClick={()=> this.joinRoom(room.id)}
          className={`${isActive} room`}
        >
          {room.name}
        </li>
      );
    });

    const ChatSession = messages.map((message, index) => {
      const user = message.senderId === currentUser.id ? "support" : "user";
      return(
        <span key={index} className={`${user} message`}>
        {message.text}
        </span>
      );
    });

    return (
      <div className="box-support">
      <div className="support-area">
      <aside className="support-sidebar">
        <h1>TUTTE LE CHAT:</h1>
        <ul>{RoomList}</ul>
      </aside>
      <section className="support-session">
        <header className="current-chat">
          <h1>{currentRoom ? currentRoom.name : "< SELEZIONA NOME CLIENTE"}</h1>
        </header>
        <div className="chat-session">{ChatSession}</div>
        <form onSubmit={this.sendMessage} className="message-form">
          <input
            className="message-input"
            autoFocus
            placeholder="scrivi un messaggio e premi INVIO"
            onChange={this.handleInput}
            value={newMessage}
            name="newMessage"
          />
        </form>
      </section>


      </div>
      <div className="manage-chat">
          <h1>GESTIONE DELLE CHAT E DEI CLIENTI:</h1>
          <h2><a href="https://dash.pusher.com/chatkit/ad7d7c1e-cb76-4410-96a2-c41640d70d80/console"> → DASHBOARD ←   </a></h2>
          <h3>Cancellando una chat bisognerà successivamente cancellare anche il cliente e viceversa!
          <br />Altrimenti ci sarà un sovraccarico di dati, poco incomprensibili.
          <br />É bene tenere la lista ordinata!
          <br /> <br /> <br /> ATTENZIONE:
          <br />NON CANCELLARE PER NESSUNA RAGIONE IL NOME UTENTE: support </h3>

          <br /> <br /> <br />
          <h2><a href="https://dash.pusher.com/chatkit/ad7d7c1e-cb76-4410-96a2-c41640d70d80"> → OVERVIEW ←   </a></h2>
          <h3>Per il conteggio degli utenti e dei messaggi</h3>

      </div>
    </div>
  );
}
}

export default Support;
